window.onload = function(){
 var linkmsg=document.getElementById("linkmsg");
 linkmsg.style.visibility="visible";
 linkmsg.innerHTML="カラーを選択してください";
}
// カラー
function checkBtn(){
checkOption()
 var idColor = document.getElementsByName( "colortype" ) ;
 var strColor = "";
 var i=0;
 for ( strColor="", i=idColor.length; i--; ) {
  if ( idColor[i].checked ) {
   strColor = idColor[i];
   break ;
  }
 }
 var linkmsg=document.getElementById("linkmsg");
 var strErrmsg="";
 if(strColor=""){
  linkmsg.style.visibility="visible";
  strErrmsg="カラーを選択してください";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =true;
 }else{
  linkmsg.style.visibility="hidden";
  linkmsg.innerHTML="";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =false;
 }
 if(strErrmsg!=""){
 linkmsg.innerHTML=strErrmsg;
    }
}

/*内容リセット*/
function checkOption(){
 document.getElementById("price").value=""
 cart_price.innerHTML =""+" 円";
 cart_haba.innerHTML="";
 cart_depth.innerHTML="";
 cart_color.innerHTML="";
 cart_option.innerHTML="";
 linkmsg.style.visibility="hidden"; //190208追加
}
const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_top\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,haba,depth,board,color){
this.url=url;this.haba=haba;this.depth=depth;this.board=board;this.color=color;}
function searchURL(strHaba,strDepth,strOption,strColor){
var strErr;
var intDepth=document.getElementById("depth").value
var intHaba=document.getElementById("haba").value
intDepth=parseInt(intDepth);
intHaba=parseInt(intHaba);
//幅チェック
if (intHaba < 125){
 strErr="幅125cm未満";
}else if (intHaba > 180){
  strErr="幅181cm以上";
}
//奥行チェック
if (intDepth < 60){
 strErr="奥行60cm未満";
}else if (intDepth > 90){
  strErr="奥行91cm以上";
}
if(strErr){document.getElementById("price").value="";
return strErr+"はオーダー不可です。";}

//ベース価格
var basePrice = [79000,102000,114000,124000,156000,168000,149000];
var sellPrice;

if(strColor == "wood"){
    sellPrice = basePrice[0];
}else if(strColor == "nail" || strColor == "black"){
    sellPrice = basePrice[1];
}else if(strColor == "bp"){
    sellPrice = basePrice[2];
}else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){
    sellPrice = basePrice[3];
}else if(strColor == "kzw"){
    sellPrice = basePrice[5];
}else if(strColor == "kz"){
    sellPrice = basePrice[4];
}else if(strColor == "kme"){
    sellPrice = basePrice[6];
}
  return sellPrice;
}
/*リストから商品URLを取得*/
function checkURL(strHaba,strDepth,strOption,strColor){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].board==strOption && goods[i].color==strColor){
return goods[i].url;}}
return false;
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
 checkOption()
 
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strDepth=document.getElementById("depth").value;
var strHaba=document.getElementById("haba").value;
var idColor = document.getElementsByName( "colortype" ) ;
var idOption = document.getElementsByName( "option" ) ;
var strColor = "";
var strOption = "";
var i=0;
var c=0;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
     if( idColor[i].id.slice(0,4)=="wood" ){
         strColor = idColor[i].id.slice(0,4);
     }else if( idColor[i].id.slice(0,3)=="kzw" ){
         strColor = idColor[i].id.slice(0,3);
     }else if( idColor[i].id.slice(0,2)=="kz" ){
         strColor = idColor[i].id.slice(0,2);
     }else if( idColor[i].id.slice(0,3)=="kme" ){
         strColor = idColor[i].id.slice(0,3);
     }else{
         strColor = idColor[i].id;
     }
  var valueColor = idColor[i].value ;
  break ;
 }
}
for ( strOption="", c=idOption.length; c--; ) {
 if ( idOption[c].checked ) {
  strOption = idOption[c].id ;
  var valueOption = idOption[c].value ;
  break ;
 }
}
if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
if (isNumber(strDepth)==false){
alert("奥行は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}

//上月の場合と大阪の場合各課で変更
if( strColor=="kz" | strColor=="kzw" ){
document.getElementById("item_id").value="0010089788";
document.getElementById("inventory_id").value="181572";
}else{
document.getElementById("item_id").value="0010089523";
document.getElementById("inventory_id").value="180367";
}
  
  
//SKU（タモ/メープル/ウォールナット/タモグレー/タモブラックを選択した際はSKUを5555a00017としてカート追加、それ以外は5555a00016）

if( valueColor == "タモ" || valueColor == "メープル" || valueColor == "ウォールナット" || valueColor == "タモグレー" || valueColor == "タモブラック"){
  document.getElementById("sku").value="5555a00017"
}else{
  document.getElementById("sku").value="5555a00016"
}
  

document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=strDepth+"cm"
document.getElementById("choice3").value=valueColor
document.getElementById("choice4").value=valueOption



//商品ページの有無チェック
var comcode=checkURL(strHaba,strDepth,strOption,strColor);
//抗菌kme個別ページアップされたら条件変更
if(valueColor=="オーク" || valueColor=="ブラックウッド"){
if (!comcode=="" && strColor!="kme"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML=valueColor+"は別注色のため既製品とは金額が異なります。";
}}
else if (!comcode=="" && strColor!="kme"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}

/*2022/2/24まで
if (!comcode=="" && strColor!="kme" && valueColor!=="強化紙オーク"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
if (!comcode=="" && strColor!="kme" && valueColor=="強化紙オーク"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="リーズナブル木目オークは別注色のため金額が異なります。";
}*/

var url=searchURL(strHaba,strDepth,strOption,strColor);


if(!url){
alert("幅を入力してください");
return false;
}

var intUnit
if (isNaN(url)==false){
 intUnit=parseInt(url)/1000;
 document.getElementById("price").value =parseInt(url).toLocaleString()+" 円";
 cart_price.innerHTML =parseInt(url).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_depth.innerHTML=strDepth;
 cart_color.innerHTML=valueColor;
 cart_option.innerHTML=valueOption;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice5").value=url;
return false;
}
function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;
 var text = document.frm.inventory_id.value;
 var price = document.frm_detail.price.value;
    if(choice1=="" || choice2=="") {
        alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
        return false;
        }
    if(price=="") {
        alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
        return false;
        }
     return true;
}
goods = new Object();
goods[0] =new setGoods("set00000009410","180","90","sq","wood");
goods[1] =new setGoods("set00000009415","180","90","sq","nail");
goods[2] =new setGoods("set00000009416","180","90","sq","black");
goods[3] =new setGoods("set00000009417","180","90","sq","bp");
goods[4] =new setGoods("set00000009418","180","90","sq","ww");
goods[5] =new setGoods("set00000009419","180","90","sq","gs");
goods[6] =new setGoods("set00000009420","180","90","sq","mb");
goods[7] =new setGoods("set00000009493","180","90","sq","kz");
goods[8] =new setGoods("set00000009496","180","90","sq","kzw");
goods[9] =new setGoods("未登録","180","90","sq","kme");